namespace GeniuzPOS.Member {
    export interface MbReport01Form {
        MbId: Serenity.StringEditor;
        MbType: Serenity.StringEditor;
        MemberTypeDesc: Serenity.StringEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        NetSales: Serenity.DecimalEditor;
        NetSalesExVat: Serenity.DecimalEditor;
        VatOfNetSales: Serenity.DecimalEditor;
        AllItemCharge: Serenity.DecimalEditor;
        VatOfCharge: Serenity.DecimalEditor;
        MbNameT: Serenity.StringEditor;
        MbAddress: Serenity.StringEditor;
        MbAmphur: Serenity.LookupEditor;
        MbTumbol: Serenity.LookupEditor;
        MbProvince: Serenity.LookupEditor;
        MbZipCode: Serenity.StringEditor;
        MbGender: Serenity.RadioButtonEditor;
        MbNation: Serenity.StringEditor;
        MbRace: Serenity.StringEditor;
        MbOccupation: Serenity.StringEditor;
        MbBirthDay: Serenity.DateEditor;
        MbCardStatus: Serenity.IntegerEditor;
        MbAccumPoint: Serenity.DecimalEditor;
        MbMemo: Serenity.TextAreaEditor;
        PluDtList: MbReport_01_Dt_Plu_PluEditor;
        DtList: MbReport01_DtEditor;
    }

    export class MbReport01Form extends Serenity.PrefixedContext {
        static formKey = 'Member.MbReport01';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MbReport01Form.init)  {
                MbReport01Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.LookupEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = s.DateEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.TextAreaEditor;
                var w7 = MbReport_01_Dt_Plu_PluEditor;
                var w8 = MbReport01_DtEditor;

                Q.initFormType(MbReport01Form, [
                    'MbId', w0,
                    'MbType', w0,
                    'MemberTypeDesc', w0,
                    'GrossSales', w1,
                    'AllItemDiscount', w1,
                    'NetSales', w1,
                    'NetSalesExVat', w1,
                    'VatOfNetSales', w1,
                    'AllItemCharge', w1,
                    'VatOfCharge', w1,
                    'MbNameT', w0,
                    'MbAddress', w0,
                    'MbAmphur', w2,
                    'MbTumbol', w2,
                    'MbProvince', w2,
                    'MbZipCode', w0,
                    'MbGender', w3,
                    'MbNation', w0,
                    'MbRace', w0,
                    'MbOccupation', w0,
                    'MbBirthDay', w4,
                    'MbCardStatus', w5,
                    'MbAccumPoint', w1,
                    'MbMemo', w6,
                    'PluDtList', w7,
                    'DtList', w8
                ]);
            }
        }
    }
}
